// 本地存储key
import { APP_CHANNEL } from 'common/utils/variables'
export const STORAGE_KEY = 'WeiyiStat_pb_export2'
export const STORAGE_NG_TIME = 1000 * 60 * 60 * 24 * 7 // 1周

// 导出模版的选项
// type: 0-PDF 1-Word
const COVER_IMAGE_PATH = 'https://media.winbaoxian.com/autoUpload/common'
const COVER_IMAGE_PATH2 = 'https://media.winbaoxian.com/assets-uploader'
const COVER_IMAGE_PARAMS = '?x-oss-process=image/resize,m_mfit,h_250,w_190'
export const BXS_COVER_OPTIONS = [
  {
    type: 0,
    label: '简约版',
    value: 1,
    image: `${COVER_IMAGE_PATH}/e4a4ee49-417d-4a40-ac6a-353180de9c21.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_jianyue'
  },
  {
    type: 0,
    label: '时尚版',
    value: 4,
    image: `${COVER_IMAGE_PATH2}/%E5%B0%81%E9%9D%A2-1758693232372.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shishang'
  },
  {
    type: 0,
    label: '商务版',
    value: 2,
    image: `${COVER_IMAGE_PATH}/153b6ee7-2d0c-4cf5-8df6-b83cf6647ebe.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shangwu'
  },
  {
    type: 0,
    label: '微易经纪',
    value: 3,
    image: `${COVER_IMAGE_PATH}/f045e94f-75f9-44df-bce6-94b873faf05a.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_weiyi'
  },
  {
    type: 1,
    label: '简约版',
    value: 1,
    image: `${COVER_IMAGE_PATH}/e4a4ee49-417d-4a40-ac6a-353180de9c21.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_jianyue'
  },
  {
    type: 1,
    label: '时尚版',
    value: 4,
    image: `${COVER_IMAGE_PATH2}/%E5%B0%81%E9%9D%A2-1758693232372.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shishang'
  },
  {
    type: 1,
    label: '商务版',
    value: 2,
    image: `${COVER_IMAGE_PATH}/153b6ee7-2d0c-4cf5-8df6-b83cf6647ebe.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shangwu'
  },
  {
    type: 1,
    label: '微易经纪',
    value: 3,
    image: `${COVER_IMAGE_PATH}/f045e94f-75f9-44df-bce6-94b873faf05a.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_weiyi'
  },
]
export const NUOYA_COVER_OPTIONS = [
  {
    type: 0,
    label: '诺亚荣耀',
    value: 5,
    image: `${COVER_IMAGE_PATH}/eb166213-51bf-4a41-8f08-cac93b89b3b3.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_weiyi'
  },
  {
    type: 0,
    label: '简约版',
    value: 1,
    image: `${COVER_IMAGE_PATH}/e4a4ee49-417d-4a40-ac6a-353180de9c21.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_jianyue'
  },
  {
    type: 0,
    label: '时尚版',
    value: 4,
    image: `${COVER_IMAGE_PATH2}/%E5%B0%81%E9%9D%A2-1758693232372.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shishang'
  },
  {
    type: 0,
    label: '商务版',
    value: 2,
    image: `${COVER_IMAGE_PATH}/153b6ee7-2d0c-4cf5-8df6-b83cf6647ebe.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shangwu'
  },
  {
    type: 1,
    label: '简约版',
    value: 1,
    image: `${COVER_IMAGE_PATH}/e4a4ee49-417d-4a40-ac6a-353180de9c21.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_jianyue'
  },
  {
    type: 1,
    label: '时尚版',
    value: 4,
    image: `${COVER_IMAGE_PATH2}/%E5%B0%81%E9%9D%A2-1758693232372.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shishang'
  },
  {
    type: 1,
    label: '商务版',
    value: 2,
    image: `${COVER_IMAGE_PATH}/153b6ee7-2d0c-4cf5-8df6-b83cf6647ebe.png${COVER_IMAGE_PARAMS}`,
    stat: 'mould_shangwu'
  },
]

export const BXZ_COVER_OPTIONS = BXS_COVER_OPTIONS.filter(o => o.value !== 3)

const coverMap = {
  'BXS': BXS_COVER_OPTIONS,
  'NUOYA': NUOYA_COVER_OPTIONS,
  'BaoXiaoZhu': BXZ_COVER_OPTIONS,
  'H5_BXZ': BXZ_COVER_OPTIONS,
  'WXMP_BXZ': BXZ_COVER_OPTIONS,
}

export const COVER_OPTIONS = coverMap[APP_CHANNEL] || BXS_COVER_OPTIONS

// 内容配置
export const CONTENT_OPTIONS = [
  {
    value: 'introduceShow',
    label: '公司介绍',
    stat: 'gs',
    children: {
      key: 'introduceCompanyId',
      value: null,
      options: [
        { value: null, label: '不显示' },
        { value: 40, label: '微易经纪' }
      ].filter(e => !(['NUOYA', 'BaoXiaoZhu', 'H5_BXZ', 'WECHAT_BXZ', 'WXMP_BXZ'].includes(APP_CHANNEL) && e.value === 40))
    }
  },
  {
    value: 'ideaShow',
    label: '保险理念',
    stat: 'linian',
    children: {
      key: 'ideaId',
      value: null,
      options: [
        { value: null, label: '不显示' },
        { value: 1, label: '家庭资产4大账户' },
        { value: 2, label: '人生7张保单' },
        { value: 3, label: '买重疾险的10大理由' },
        { value: 4, label: '年金险理念' },
        { value: 5, label: '意外险理念' },
        { value: 6, label: '医疗险理念' }
      ]
    }
  },
  {
    value: 'diseaseShow',
    label: '病种清单',
    children: {
      key: 'diseaseShow',
      value: null,
      options: [
        { value: true, label: '显示' },
        { value: null, label: '不显示' }
      ]
    },
    stat: 'bingzhong'
  },
  {
    value: 'interestShow',
    label: '利益表格',
    stat: 'liyi',
    children: {
      key: 'interestType',
      value: null,
      options: [
        { value: null, label: '不显示' },
        { value: 1, label: '逐年显示' },
        { value: 5, label: '5岁倍数' },
        { value: 10, label: '10岁倍数' }
      ]
    }
  },
  {
    value: 'problemShow',
    label: '常见问题',
    children: {
      key: 'problemShow',
      value: null,
      options: [
        { value: true, label: '显示' },
        { value: null, label: '不显示' }
      ]
    },
    stat: 'wenti'
  },
  {
    value: 'cardType',
    label: '个人名片',
    stat: 'mingpian',
    children: {
      key: 'cardType',
      value: 1,
      options: [
        { value: 1, label: '简明' },
        { value: 2, label: '详细' }
      ].filter(e => !(['NUOYA', 'H5_BXZ'].includes(APP_CHANNEL) && e.value === 2))
    }
  }
]

// 寄语
export const REMAKRS_OPTIONS = [
  '人生风险无处不在，合理的保障规划可转移未来不可预知的风险。建议您提前规划足额保障，安享保险人生。',
  '如果我们能预知未来，我们就可以等待，但没有谁能做到。所以，只有预先准备。保险就是为明天做准备，在你失意的时候能够帮助你，不至使你的生活滑入深渊，让你能享有安逸的生活。一份真正握在手中的保障，是你坚强的经济后盾。',
  '一张保单拥有4大承诺：1，政府监督保险公司运作的承诺；2，保险公司履行契约的承诺；3，所有保户互助共济的承诺；4，我对您终身专业服务的承诺！',
  `具有责任感的人说：“只要有我在，我就照顾你。”
买保险后可以更大声说：“只要你在，我就照顾你！”
保险使你的爱更实在更长久。保险就是：家人，我爱你！`,
  '没有人能预知生命中的不幸，我们能做的就是在我们还安好的时候，为自己购买足够的人寿保险，因为一旦发生不测，只有保险会将我们的爱延续到父母、妻儿、兄弟姐妹的生命中，保险即是远见也是责任。',
  '保险的意义，只是今日做明日的准备，生时做死时的准备，父母做儿女的准备，儿女幼小时做儿女长大时准备，如此而已。今天预备明天，这是真稳健；生时预备死时，这是真旷达；父母预备儿女，这是真慈爱。'
]